import React from "react";

import { ROLE_PERMISSION_GROUPS, togglePermission } from "../constants/rolePermissions";

// Checkbox list of role permissions, one section per sidebar page
const RolePermissionChecklist = ({ permissions, onChange, disabled = false, canGrantSuperAdmin = false }) => (
  <>
    {ROLE_PERMISSION_GROUPS.map((group) => {
      const groupDisabled = disabled || (group.superAdminOnly && !canGrantSuperAdmin);
      return (
        <section key={group.title}>
          <h3 className="text-md font-semibold mt-8">{group.title}</h3>
          <div className="flex flex-wrap md:items-center mt-4 gap-y-4">
            {group.permissions.map((permission) => (
              <label key={permission.key} className="w-full sm:w-1/2 md:w-1/3 text-gray-500 font-bold">
                <input
                  className="mr-2 leading-tight"
                  type="checkbox"
                  disabled={groupDisabled}
                  checked={permissions[permission.key] === true}
                  onChange={(e) => onChange(togglePermission(permissions, permission.key, e.target.checked))}
                />
                <span className="text-sm">{permission.label}</span>
              </label>
            ))}
          </div>
        </section>
      );
    })}
  </>
);

export default RolePermissionChecklist;
